import React, { Component } from 'react'

class NotAuthenticated extends Component {
    render() {
        return (
            <div className="lone_wrapper">
                You are not allowed to access this area.
            </div>
        )
    }
}

export default NotAuthenticated


// WEBPACK FOOTER //
// ./src/components/NotAuthenticated.js